<template>
    <el-popover trigger="click" v-if="datas" class="finance-view">
        <el-table :data="dbDatas">
            <el-table-column v-if="type == 'E'" width="50" property="address" label="附件">
                <template slot-scope="expend">
                     <i v-if="expend.row.hasFile == 'Y'" class="el-icon-paperclip" style="cursor: pointer" @click="showFile(expend.row.id)"></i>
                 </template>
            </el-table-column>

            <el-table-column :width="twidth" property="id" label="单号"></el-table-column>
            <el-table-column width="120" property="time" label="时间">
                <template slot-scope="expend">{{ $tools.timestampToDay(expend.row.time)}}</template>
            </el-table-column>
            <el-table-column width="100" property="address" label="金额">
                <template slot-scope="expend">{{ $tools.parsecost(expend.row.cost, true)}}</template>
            </el-table-column>

            <el-table-column v-if="type == 'E'" width="200" property="remark" label="备注" :show-overflow-tooltip="true"></el-table-column>
        </el-table>

        <el-link type="primary" @click="getMsg" slot="reference" v-if="datas">查看</el-link>

        <sn-file-dialog :show.sync="showFileDialog" :relateId="relateId" relateType="FinanceExpense" :canEdit="false"></sn-file-dialog>
    </el-popover>
</template>

<script>
import SnFileDialog from '../components/SnFileDialog.vue';
export default {
    components: {SnFileDialog  },
    props: {
        datas: { type: String, default: '' },
        type: { type: String, default: null },
    },
    data() {
        return { 
            twidth: 200, 
            dbDatas: [],
            showFileDialog: false,
            relateId: null,
        };
    },
    methods: {
        getMsg() {
            let _this = this;
            let url = null;

            if (_this.type == "B") {
                url = "finance/bill/financeView";
                _this.twidth = 500;
            } else if (_this.type == "A") {
                url = "finance/expense/account/financeView";
            } else {
                url = "finance/expense/financeView";
            }

            _this.$http.post(
                [url, { ids: _this.datas }],
                [
                    function (data) {
                        _this.dbDatas = data;
                    },
                ],
                "none"
            );
        },
        showFile(id) {
            let _this = this;
            _this.relateId = id;
            _this.showFileDialog = true;
        }
    },
    mounted() {},
};
</script>

<style lang="scss">
</style>